import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import CalendarIcon from "../../../../assets/images/Icons/calendarIcon.svg";
import DownArrow from "../../../../../src/assets/images/Icons/icons/down_arrow.svg";
import UpArrow from "../../../../../src/assets/images/Icons/icons/up_arrow.svg";
import { FaCalendar } from "react-icons/fa";
import {
  makeAjax,
  respStatus,
  url,
  showMessage,
  gameList,
} from "../../../../helpers/global_helper";
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { formatPrice, formatPricewithdecimal } from "../../../NumberFormat";
import InnerPopup from "../../../Popups/InnerPopup";
import InvoiceTogleBetPopup from "./InvoiceTogleBetPopup";
import { setTotalNoResult } from "../../../../redux/actions";
import StatementWinPopup from "./StatementWinPopup";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

const InvoiceTogel = (props) => {
  const dispatch = useDispatch();
  const device = useSelector((state) => state.CommonConfig.device_type);
  const [startDate, setStartDate] = useState(new Date());
  // const [gameName, setGameName] = useState([]);
  const [gameName, setGameName] = useState(gameList);
  const marketList = useSelector((state) => state.CommonConfig.marketList);
  const [selectGameName, setSelectGameName] = useState(marketList[0].game_id);

  // const pageNumber = useSelector((state) => state.paginationData.pageNumber)
  // const perPage = useSelector((state) => state.paginationData.dataInOnePage)

  const [transectionData, setTransectionData] = useState([]);
  const [showBetPopup, setBetShowPopup] = useState(false);
  const [showWinStatmentPopup, setWinStatementPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [totalData, setTotalData] = useState([]);
  const [win, setWin] = useState("");
  const [subgame, setSubgame] = useState("");

  const date = new Date(startDate);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Adding 1 to month because it's zero-indexed
  const day = date.getDate().toString().padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}`;

  // api for Game list
  // const featchGameList = () => {
  //   makeAjax(url.TOGEL_API.listGame).then((response) => {
  //     if (response.status != respStatus["SUCCESS"]) {
  //       if (response.code != "validation_error") {
  //         showMessage(response);
  //         return;
  //       }
  //       showMessage(response);
  //       return;
  //     }
  //     setGameName(response.data);
  //   });
  // };
  // useEffect(() => {
  //   featchGameList();
  // }, []);

  useEffect(() => {
    featchTransectionList();
    const container = document.querySelector(".informasi_tble_result");
    if (container) {
      container.scrollTop = 0;
    }
  }, []);

  const featchTransectionList = () => {
    setLoading(true);
    let reqData = {
      // page: pageNumber,
      date: formattedDate,
      game_id: parseInt(selectGameName),
      // date: "2024-05-28",
      // game_id: 201,
      // length: perPage,
    };
    makeAjax(url.TOGEL_API.listInvoiceTogelData, reqData).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage(response);
          return;
        }
        showMessage(response);
        return;
      }
      setTotalData(response.data);

      // dispatch(setTotalNoResult(response.data.list_subgame.length))

      setTransectionData(response.data.list_subgame);
      setLoading(false);
    });
  };
  const CustomInput = ({ value, onClick }) => (
    <div style={{ position: "relative" }} className="custom_calendar">
      <input
        type="text"
        value={value}
        onClick={onClick} // This opens the calendar on input click
        readOnly // Prevent direct text input
      />
      <button
        onClick={onClick} // This also opens the calendar on icon click
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
        }}
      >
        {/* <img src={CalendarIcon} alt="" /> */}
        <FaCalendar />
      </button>
    </div>
  );

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("asc");
    }
  };

  const sortedData = () => {
    if (sortBy === "buy" || sortBy === "pay") {
      return transectionData.slice().sort((a, b) => {
        const aValue = parseFloat(a[sortBy]);
        const bValue = parseFloat(b[sortBy]);
        return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
      });
    } else if (sortBy === "pay" || sortBy === "win") {
      return transectionData.slice().sort((a, b) => {
        const aValue = parseFloat(a[sortBy]);
        const bValue = parseFloat(b[sortBy]);
        return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
      });
    } else if (sortBy) {
      return transectionData.slice().sort((a, b) => {
        const aValue = a[sortBy].toLowerCase();
        const bValue = b[sortBy].toLowerCase();
        return sortOrder === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      });
    }
    return transectionData;
  };
  const handleGameSelectOptions = (e) => {
    const selectedValue = e.target.value;
    setSelectGameName(selectedValue);
  };

  const handleSearchData = () => {
    const container = document.querySelector(".informasi_tble_result");
    if (container) {
      container.scrollTop = 0;
    }
    // props.handlePageNo();

    featchTransectionList();
  };

  const closeInvoiceTogelPopup = () => {
    setBetShowPopup(false);
  };
  const closeWinStatementPopup = () => {
    setWinStatementPopup(false);
  };
  const handleInvoiceToglePopup = (win, subgame) => {
    setWin(win);
    setSubgame(subgame);
    setBetShowPopup(true);
  };
  const handleStatementWinToglePopup = (win, subgame) => {
    setWin(win);
    setSubgame(subgame);
    setWinStatementPopup(true);
  };

  return (
    <div className="trasaction_popup">
      <div className="trasaction_top_bar">
        <div className="calendar">
          <DatePicker
            // showIcon
            customInput={<CustomInput />}
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            dateFormat="yyyy-MM-dd"
            maxDate={new Date()}
          />
        </div>
        <div className="all_game_dropdown">
          <select className="dropdown" onChange={handleGameSelectOptions}>
            {marketList.length > 0 &&
              marketList.map(({ game_id, game_name }) => (
                <option key={game_id} value={game_id}>
                  {game_name}
                </option>
              ))}
          </select>
        </div>
        <div className="search">
          <button onClick={handleSearchData}>{props.t("search")}</button>
        </div>
      </div>

      {/* table */}
      <div
        className={device === "Desktop" ? "informasi_tble_result" : "container"}
      >
        <table>
          <thead>
            <tr>
              <th>No.</th>
              <th onClick={() => handleSort("name")}>
                {props.t("game")}
                <span className="sorting_arrow">
                  {sortBy === "name" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
              <th onClick={() => handleSort("buy")}>
                {props.t("buy")}
                <span className="sorting_arrow">
                  {sortBy === "buy" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
              <th onClick={() => handleSort("pay")}>
                {props.t("pay")}
                <span className="sorting_arrow">
                  {sortBy === "pay" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
              <th onClick={() => handleSort("win")}>
                {props.t("totalWin")}
                <span className="sorting_arrow">
                  {sortBy === "totalWin" && sortOrder === "asc" ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {!loading &&
              (sortedData().length === 0 ? (
                <tr className="table_data_empty_row ">
                  <td colSpan="5">{props.t("data_not_found")}</td>
                </tr>
              ) : (
                sortedData().map((item, index) => {
                  return (
                    <tr
                      key={index}
                      className={index % 2 === 0 ? "even-row" : "odd-row"}
                    >
                      <td>{index + 1}</td>
                      <td>
                        <span
                          className="total_count link"
                          onClick={() =>
                            handleInvoiceToglePopup(item.win, item.subgame)
                          }
                        >
                          {item.name}
                        </span>
                      </td>
                      <td>{formatPricewithdecimal(item.buy)}</td>
                      <td>{formatPricewithdecimal(item.pay)}</td>
                      <td>
                        <span
                          className="total_count link"
                          onClick={() =>
                            handleStatementWinToglePopup(item.win, item.subgame)
                          }
                        >
                          {formatPricewithdecimal(item.win)}
                        </span>
                      </td>
                    </tr>
                  );
                })
              ))}
            <tr>
              <td colSpan={2}> Total</td>
              <td>{formatPricewithdecimal(totalData.totalBuy)}</td>
              <td>{formatPricewithdecimal(totalData.totalPay)}</td>
              <td>{formatPricewithdecimal(totalData.totalWin)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {showBetPopup && (
        <InvoiceTogleBetPopup
          onClose={closeInvoiceTogelPopup}
          gameid={totalData.gameId}
          period={totalData.period}
          act={win}
          subgame={subgame}
        />
      )}
      {showWinStatmentPopup && (
        <StatementWinPopup
          onClose={closeWinStatementPopup}
          gameid={totalData.gameId}
          period={totalData.period}
          act={win}
          subgame={subgame}
        />
      )}
    </div>
  );
};

export default withTranslation()(InvoiceTogel);
